module.exports = __webpack_public_path__ + "img/warning.3dd2409f.svg";